import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/rules/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Rule'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
